module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/feature_1-f9dc96d33ce0d563175abc6316a08501.png";